<template lang="pug">
  app-page(title="Модерация специалистов" :fab-items="items")
    app-toolbar(title="Управление специалистами")
       app-toolbar-item.ml-12.text-lowercase(label="Статус" all="Все" :items="statuses" key-name="title" @select="filterByStatus") {{ selectedModerStatus | moderStatusNamed }}
       app-toolbar-item.ml-12.text-lowercase(label="Специалист" all="Все" :items="types" key-name="title" @select="filterByType") {{ selectedType | typeNamed }}

    // Spec list 
    //
    div
      v-layout(row wrap v-if="specList.length > 0")
        v-flex.px-4(xs4 v-for="(a, index) in specList" :key="index"  )
          app-card(@click.native="selectSpec(a)")
            app-card-header 
              | {{ a.specialistType.title }}
            app-card-body
              app-card-title {{fullName(a.persona)}}
              app-card-caption.mt-2(v-if="!a.moderated") Требуется модерация
              app-card-caption.mt-2(v-else) Модерация пройдена
              app-card-caption.mt-2(v-if="a.specialistGroup") Группа: {{ a.specialistGroup.groupName }}


</template>

<script>
import { AppToolbarItemDivider } from '@/components'
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  data() {
    return {
      spec: null,
      statuses: [{value: false, title:'Требуется модерация'}, {value: true, title:'Модерация пройдена'}],
      items: [
        AppToolbarItemDivider,
        {icon:'person', title:'Зарегистрировать специалиста', action: () => this.addSpec() },
        {icon:'person', title:'Управление группами', action: () => this.$router.push({name: 'GroupManage'}) },
      ]
    }
  },

  methods: {
    ...mapMutations('specialist', [ 'selectType', 'selectModerStatus']),
    fullName: (pers) => {
      return pers.personaType.value==1?pers.orgName:pers.name
    },
    filterByType(type) {
      this.selectType(type)
    },
    filterByStatus(status) {
      this.selectModerStatus(status)
    },
    selectSpec (item) {
      this.$router.push({name: 'SpecialistEditProfile', params: {specId: item.id}})
    },
    addSpec () {
      this.$router.push({ path: `/specialist/register` })
    },
  },

  filters: {
    typeNamed: type => {
      return type != null ? type.title : 'Все'
    },
    moderStatusNamed: status => {
      return status != null ? status.title : 'Все'
    },
  },

  computed: {
    ...mapState('specialist', [ 'selectedType', 'selectedModerStatus']),
    ...mapGetters('specialist', ['specs','isSpecsLoaded', 'types']),
    specList() {
      let list = (this.selectedType == null) ? this.specs : this.specs.filter(c => c.specialistType.value == this.selectedType.value)
      list = (this.selectedModerStatus == null) ? list : list.filter(c => c.moderated == this.selectedModerStatus.value)
      return list
    }
  },
  created() {
    if(!this.isSpecsLoaded) this.selectModerStatus(this.statuses[0])
    this.$store.dispatch('specialist/LOAD_SPECS')
  }
}


</script>

<style scoped>
</style>
